/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Footprint } from '../../models/footprint';
import { UploadFootprintDto } from '../../models/upload-footprint-dto';

export interface MyPatientControllerCreateFootprint$Params {
  id: number;
      body: UploadFootprintDto
}

export function myPatientControllerCreateFootprint(http: HttpClient, rootUrl: string, params: MyPatientControllerCreateFootprint$Params, context?: HttpContext): Observable<StrictHttpResponse<Footprint>> {
  const rb = new RequestBuilder(rootUrl, myPatientControllerCreateFootprint.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Footprint>;
    })
  );
}

myPatientControllerCreateFootprint.PATH = '/api/my-patients/{id}/footprint';
